export const patterns = {
    space: /\s/g
}